import * as React from 'react';

import { usePathType, useUndergroundIcon } from './hooks';
import * as styles from './Underground.css';
import { IPromoOfferUnderground } from '../../types/promoOffersSelection';

interface IUndergroundProps {
  underground: IPromoOfferUnderground;
}

export const Underground: React.FC<IUndergroundProps> = ({ underground }) => {
  const { lineColor, transportType, name, icon, time } = underground;

  const undergroundIcon = useUndergroundIcon(icon);
  const transport = usePathType(transportType);

  return (
    <div className={styles['underground']}>
      <span className={styles['underground-icon']} style={{ color: `#${lineColor}` }}>
        {undergroundIcon}
      </span>
      <span className={styles['underground-text']}>{name}</span>
      <span className={styles['underground-time']}>
        {transport}
        {time} мин
      </span>
    </div>
  );
};
